module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BrotherBlessingView.js"));
	}, "BrotherBlessingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BrotherBlessingView!./src/pages/Shop/Home/MemberBirthday/BrotherBlessing/BrotherBlessingView.js
// module id = 918
// module chunks = 438